import { Anulicense } from "../license";

const OfferSection = () => {
  return (
    <section id="Services">
      <div className="pb-20">
        <div className="mt-20">
          <div className="flex justify-center mb-20 ">
            <div className="sm:w-[70%] w-full z-10 text-center relative">
              <h4 className="lg:text-[24px] xl:text-[24px] md:text-[24px] xl:leading-[60px] lg:leading-[60px] md:leading-[60px] text-[18px] leading-[30px] font-secondary_font font-bold text-[#aa8210]">
                What We Offers
              </h4>
              <h2 className="lg:text-[50px] xl:text-[50px] md:text-[50px] text-[28px] xl:leading-[60px] lg:leading-[60px] md:leading-[60px] leading-[35px] font-medium">
                We Provide Lot’s Of Printing & Branding Service
              </h2>
              <span className="font-secondary_font lg:text-[150px] xl:text-[150px] md:text-[150px] text-[90px] shadow-text">
                Services
              </span>
            </div>
          </div>
          <div className="continer mx-auto ">
            <div className="lg:flex-row xl:flex-row flex-col gap-5 flex lg:mt-20 xl:mt-20 lg:mx-10 xl:mx-10 mx-2 xl:items-center justify-center">
              <div className="flex flex-col gap-5">
                <div className="seciver-offer-card px-5 py-10 bg-[#fec931]">
                  <div>
                    <h1 className="font-global_font text-center font-medium text-[20px]">
                      Design & Branding
                    </h1>
                  </div>
                  <div className="mt-5">
                    <ul className="list-inside list-disc font-global_font font-light">
                      <li>Logo Creation</li>
                      <li>Corporate Branding</li>
                      <li>Vehicle Branding</li>
                      <li>Brochures</li>
                      <li>Product Catalogs</li>
                    </ul>
                  </div>
                </div>

                <div className="seciver-offer-card px-5 py-10 bg-[#fec931]">
                  <div>
                    <h1 className="font-global_font text-center font-medium text-[20px]">
                      Screen Printing
                    </h1>
                  </div>
                  <div className="mt-5 flex">
                    <ul className="list-inside list-disc font-global_font font-light">
                      <li>Wedding Cards</li>
                      <li>Textiles</li>
                      <li>Vehicle Branding</li>
                      <li>Wood</li>
                      <li>Acrylic</li>
                    </ul>
                  </div>
                </div>

                <div className="seciver-offer-card px-5 py-10 bg-[#fec931]">
                  <div>
                    <h1 className="font-global_font text-center font-medium text-[20px]">
                      Offeset Printing
                    </h1>
                  </div>
                  <div className="mt-5 flex">
                    <ul className="list-inside list-disc font-global_font font-light">
                      <li>Hande-out/Leaflets/Flyers</li>
                      <li>News Letters</li>
                      <li>Office Stationery</li>
                      <li>Brochures</li>
                      <li>Calendar</li>
                      <li>Magazines/Souvenir/Annual Reports</li>
                      <li>File Folder</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="lg:w-[50%] xl:w-[50%] seciver-offer-card-ser">
                <div className="p-5">
                  <div>
                    <h1 className="text-center font-global_font text-[25px] uppercase font-medium">
                      Indoor Signages
                    </h1>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-5">
                    <img
                      src={Anulicense.services1}
                      alt="services"
                      className="w-full h-60 sm:h-72 object-cover rounded"
                    />
                    <img
                      src={Anulicense.services2}
                      alt="services"
                      className="w-full h-40 sm:h-48 object-cover rounded"
                    />
                    <img
                      src={Anulicense.services3}
                      alt="services"
                      className="w-full h-60 sm:h-72 object-cover rounded"
                    />
                    <img
                      src={Anulicense.services4}
                      alt="services"
                      className="w-full h-40 sm:h-48 object-cover rounded"
                    />
                    <img
                      src={Anulicense.services5}
                      alt="services"
                      className="w-full h-60 sm:h-72 object-cover rounded"
                    />
                    <img
                      src={Anulicense.services6}
                      alt="services"
                      className="w-full h-40 sm:h-48 object-cover rounded"
                    />
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-5">
                <div className="seciver-offer-card px-5 py-10 bg-[#fec931]">
                  <div>
                    <h1 className="font-global_font text-center font-medium text-[20px]">
                      Outdoor Signages
                    </h1>
                  </div>
                  <div className="mt-5 flex">
                    <ul className="list-inside list-disc font-global_font font-light">
                      <li>Name Plates</li>
                      <li>Front/Back Light Board</li>
                      <li>Bill Board</li>
                      <li>2D/3D Board</li>
                      <li>Sign Board</li>
                      <li>Sandwich Board</li>
                      <li>Neon Board</li>
                      <li>Inshop Braning</li>
                    </ul>
                  </div>
                </div>

                <div className="seciver-offer-card px-5 py-10 bg-[#fec931]">
                  <div>
                    <h1 className="font-global_font text-center font-medium text-[20px]">
                      Digital Printing
                    </h1>
                  </div>
                  <div className="mt-5 flex">
                    <ul className="list-inside list-disc font-global_font font-light">
                      <li>Business Card</li>
                      <li>Posters</li>
                      <li>Gift Vouchers & Certificates</li>
                      <li>Product Catalogue & Menu Card</li>
                      <li>Id Card & Company Profiles</li>
                    </ul>
                  </div>
                </div>

                <div className="seciver-offer-card px-5 py-10 bg-[#fec931]">
                  <div>
                    <h1 className="font-global_font text-center font-medium text-[20px]">
                      Packaging
                    </h1>
                  </div>
                  <div className="mt-5 flex">
                    <ul className="list-inside list-disc font-global_font font-light">
                      <li>Corrugated Box</li>
                      <li>Product Packing Box</li>
                      <li>Stickers/Labels/Tags</li>
                      <li>Paper Bags</li>
                      <li>Gift Boxes</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OfferSection;
